
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/atlas/knowledge-and-quality",
      function () {
        return require("private-next-pages/docs/atlas/knowledge-and-quality.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/atlas/knowledge-and-quality"])
      });
    }
  